export { Sesion } from './sesion.model';
export { IProp } from './prop.interface';
export { InicioSesionModel } from './inicio-sesion.model';
export { APIError } from './api-error.model';



// WEBPACK FOOTER //
// ./src/app/@compartidos/models/index.ts